import React, { createContext, useContext, useEffect, useState } from 'react';

const ThemeContext = createContext({
  theme: 'light',
  setTheme: () => {},
});

export function ThemeProvider({ children, defaultTheme = 'light' }) {
  const [theme, setTheme] = useState(() => {
    // Read from localStorage on initial load
    const stored = localStorage.getItem('theme');
    return stored || defaultTheme;
  });

  useEffect(() => {
    const root = document.documentElement;

    // Remove all theme classes and data attributes
    root.removeAttribute('data-theme');
    root.classList.remove('dark', 'light');

    if (theme === 'dark') {
      root.classList.add('dark');
    }
    // 'light' is the default, no class needed

    localStorage.setItem('theme', theme);
    
  }, [theme]);

  return (
    <ThemeContext.Provider value={{ theme, setTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  const context = useContext(ThemeContext);
  if (!context) {
    throw new Error('useTheme must be used within a ThemeProvider');
  }
  return context;
}

export default ThemeContext;
